<template>
  <div id="app">
    <SideBar v-if="isAuthenticated && isDashboardLayout"></SideBar>
    <NavigationBar v-if="isAuthenticated && isDashboardLayout" />
    <div :class="isDashboardLayout ? 'dashboard' : 'dashboard dashboard--full'">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import SideBar from '@/components/SideBar.vue'
import Footer from '@/components/Footer.vue'
import Auth from '@/auth/auth'

export default {
  name: 'App',
  components: {
    NavigationBar,
    SideBar,
    Footer
  },
  computed: {
    isAuthenticated () {
      return Auth.getInstance().isAuthenticated
    },
    isDashboardLayout () {
      return [
        '/signup',
        '/login',
        '/account-details',
        '/account-details-owner',
        '/terms-and-conditions'
      ].indexOf(this.$route.path) === -1
    }
  }
}
</script>

<style>
@import "./assets/css/font-awesome.min.css";
@import "./assets/css/main.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue